import { render, staticRenderFns } from "./VeJwCjClassModal.vue?vue&type=template&id=67a6f718&scoped=true"
import script from "./VeJwCjClassModal.vue?vue&type=script&lang=js"
export * from "./VeJwCjClassModal.vue?vue&type=script&lang=js"
import style0 from "./VeJwCjClassModal.vue?vue&type=style&index=0&id=67a6f718&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a6f718",
  null
  
)

export default component.exports